/**
 * Pendant zu `NavigationManager` des Altclients.
 *
 * Der `AuthProvider` sitzt in `App.tsx` außerhalb des `BrowserRouter` und kann `useNavigate`
 * deshalb nicht verwenden — genau wie `LoginService` in Blazor keine Komponente ist. Ein
 * `pushState` mit anschließendem `popstate`-Ereignis versetzt den Router in denselben
 * Zustand wie `NavigateTo(url)`, ohne die Seite neu zu laden.
 */

/** Relative Ziele werden — wie in Blazor — gegen die Basisadresse `/` aufgelöst. */
function toAbsoluteUrl(url: string): string {
  return new URL(url, window.location.origin).href;
}

/** Pendant zu `NavigationManager.NavigateTo(url)`. */
export function navigateTo(url: string): void {
  const target = toAbsoluteUrl(url);
  if (target === window.location.href) {
    return;
  }

  window.history.pushState(null, '', target);
  window.dispatchEvent(new PopStateEvent('popstate', { state: null }));
}

/** Pendant zu `NavigationManager.NavigateTo(url, forceLoad: true)`. */
export function navigateToWithReload(url: string): void {
  window.location.assign(toAbsoluteUrl(url));
}
